import { useRef } from "react";
import PropTypes from "prop-types";

import Banner from "./Banner";
import JobInformation from "./JobInformation";
import FormSection from "./FormSection";

const jobData = {
  title: "Software Testing Engineer (Fresher)",
  summary: `
    We are looking for a motivated and detail-oriented Software Testing Engineer (Fresher) to join our QA team. This is an excellent opportunity for candidates who are passionate about software quality and eager to start their career in testing. You will work closely with developers and senior testers to learn testing processes and ensure the delivery of high-quality applications.
  `,
  responsibilities: [
    "Understand application requirements and assist in preparing test cases.",
    "Perform manual testing of web and mobile applications.",
    "Identify and report bugs clearly to the development team.",
    "Verify bug fixes and ensure issues are resolved.",
    "Support senior QA members in testing activities.",
    "Participate in regression testing before releases.",
  ],
  qualifications: [
    "Bachelor’s degree in Computer Science, IT, or a related field.",
    "Basic understanding of software testing concepts.",
    "Familiarity with SDLC (Software Development Life Cycle) and STLC (Software Testing Life Cycle).",
  ],
  skills: [
    "Basic documentation skills.",
    "Good analytical and problem-solving skills.",
    "Attention to detail and ability to identify issues.",
    "Basic understanding of web applications.",
    "Willingness to learn new tools and technologies.",
    "Good communication and teamwork skills.",
  ],
};

const SectionList = ({ title, items }) => (
  <div>
    <h3 className="text-[20px] font-semibold text-green-600 mb-1">
      {title}
    </h3>
    <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

    <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
      {items.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  </div>
);

SectionList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const JobDetails = () => {
  const applyFormRef = useRef(null);

  return (
    <>
      <div className="bg-white text-gray-800">
        <Banner
          config={{
            applyFormRef,
            title: jobData.title,
          }}
        />

        <div className="bg-white px-6 md:px-16 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
            
            {/* LEFT SIDE CONTENT */}
            <div className="lg:col-span-2 space-y-12">
              
              {/* SUMMARY */}
              <div>
                <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
                  Job Summary
                </h2>

                <p className="text-[#212129] text-[18px] leading-8 mb-6">
                  {jobData.summary}
                </p>

                <SectionList
                  title="Key Responsibilities"
                  items={jobData.responsibilities}
                />
              </div>

              {/* QUALIFICATIONS */}
              <SectionList
                title="Qualifications"
                items={jobData.qualifications}
              />

              {/* SKILLS */}
              <SectionList
                title="Skills & Competencies"
                items={jobData.skills}
              />
            </div>

            {/* RIGHT SIDE INFO */}
            <JobInformation />
          </div>
        </div>
      </div>

      {/* APPLY FORM */}
      <FormSection applyFormRef={applyFormRef} />
    </>
  );
};

export default JobDetails;